/**
 * Mixin for loading dialog
 */
export default {
  data() {
    return {
      /** Whether the page is currently loading */
      isLoading: true,
    }
  },
  methods: {
    /**
     * Hide loading overlay
     */
    closeLoadingDialog() {
      this.isLoading = false
      this.$store.commit('loading/closeLoadingDialog')
    },
    /**
     * Show loading overlay
     */
    openLoadingDialog() {
      this.isLoading = true
      this.$store.commit('loading/openLoadingDialog')
    },
  },
}
